import React from "react";

const NeueVerticalAlignTopStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.00018 13.8H7.00002C6.11637 13.8 5.40002 13.0837 5.40002 12.2V6.99999C5.40002 6.11634 6.11637 5.39999 7.00002 5.39999H9.00018C9.88386 5.39999 10.6002 6.11634 10.6002 6.99999V12.2C10.6002 13.0837 9.88386 13.8 9.00018 13.8Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 2.20001H13.8",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueVerticalAlignTopStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;